import { Component, OnInit } from '@angular/core';
import { AuthTokenService } from '@intranet/core/services/authtoken.service';

interface SendGridEmailAddress {
    email: string;
    name?: string;
}

interface SendGridPersonalization {
    to?: SendGridEmailAddress[];
    bcc?: SendGridEmailAddress[];
    dynamic_template_data?: { [key: string]: any };
}

interface SendGridTestMessage {
    personalizations?: SendGridPersonalization[];
    template_id?: string;
}

interface ShowTestMessagesResponse {
    messages: SendGridTestMessage[];
}

@Component({
    selector: 'app-admin-test-messages',
    templateUrl: './admin-test-messages.component.html',
    styleUrls: ['./admin-test-messages.component.scss'],
})
export class AdminTestMessagesComponent implements OnInit {
    messages: SendGridTestMessage[] = [];
    isLoading = false;

    constructor(private http: AuthTokenService) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.http.get<ShowTestMessagesResponse>('/api/Admin/ShowTestMessages').subscribe({
            next: (res: ShowTestMessagesResponse) => {
                this.messages = res?.messages || [];
                this.isLoading = false;
            },
            error: () => {
                this.messages = [];
                this.isLoading = false;
            },
        });
    }

    /** Flattens a personalization's dynamic_template_data object into
     *  labelled key/value pairs, for generic display (the shape varies
     *  by whichever template sent the message). */
    templateDataFields(personalization: SendGridPersonalization): { key: string; value: any }[] {
        const data = personalization.dynamic_template_data || {};
        return Object.keys(data).map(key => ({ key, value: data[key] }));
    }
}
